export const actionTypes = {
  SET_REST_CONTACTS: "CONTACTS:SET_REST",
  SET_CONTACTS_PRICELIST: "CONTACTS:SET_PRICELIST",
  TOGGLE_CONTACT_MESSAGE: "CONTACTS:TOGGLE_CONTACT_MESSAGE",
  SET_MESSAGE_STATUS: "CONTACTS:SET_MESSAGE_STATUS",
  SET_MESSAGE_TRIGGER: "SET_MESSAGE_TRIGGER",
  SET_BUY_LOADING: "PURCHASE:SET_BUY_LOADING",
  SET_BUY_SUCCESS: "PURCHASE:SET_BUY_SUCCESS",
}